import { DocumentValue } from '@/interfaces/documentValue';
import { DocumentValueResource, documentValueResource } from '@/resources/documentValue.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł wartości dokumentu
 *
 * @export
 * @class DocumentValueModule
 * @extends {EntityModule<DocumentValue, DocumentValueResource>}
 */
export class DocumentValueModule extends EntityModule<DocumentValue, DocumentValueResource> {
  constructor() {
    super(documentValueResource);

    this.mutations = {
      ...this.mutations,

      /**
       * Czyści zapisaną encję w store
       *
       * @param localState stan lokalny
       */
      clearEntity(localState: any): void {
        localState.data = undefined;
      }
    };

    this.actions = {
      ...this.actions,

      /**
       * Znajduje wartość dokumentu
       *
       * @param {*} context
       * @param {{documentId: number, code: string}} data
       * @returns {Promise<DocumentValue>}
       */
      find: (context: any, data: { documentId: number; code: string }): Promise<DocumentValue> => {
        return this.resource.find(data.documentId, data.code).then(value => {
          if (value) {
            context.commit('setEntity', value);
          } else {
            context.commit('clearEntity');
          }
          return value;
        });
      }
    };
  }
}

export default new DocumentValueModule();
